import T from 'i18n-react'
import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => state.values ? state.values : []
const hintSelectorFunc = state => (state.defaultValue) ? T.translate(state.defaultValue) : ''
const getValuesSelector = (path, id) => createSelectorWithPath(
  `${path}.${id}`,
  (state) => R.map(R.prop('value'))(valuesSelectorFunc(state))
)
const storageTypeSelectorFunc = state => state.storageTypes

const storageTypeSelectorHoc = (storageTypeSelector) => (
  createSelector(
    entitiesSelector,
    storageTypeSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

export {
  getValuesSelector,
}

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const hintSelector = withPath(hintSelectorFunc)
  const storageTypeSelector = withPath(storageTypeSelectorFunc)

  const storageTypeSourceSelector = storageTypeSelectorHoc(storageTypeSelector)

  return {
    hintSelector,
    valuesSelector,
    labelSelector,
    storageTypeSourceSelector
  }
}
